import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { bindActionCreators } from 'redux';
import { getOrderFulfillmentList } from '../../actions/orderFulfillment';
import noImage from '../../assets/images/noProductImg_420x420.jpg'



class Awaiting extends Component {
    constructor() {
        super()
        /* this.state = {
            connection_id :''
        } */
    }
    componentDidMount() {
        this.props.getOrderFulfillmentList(this.props.connection_id)
    }
    render() {
        const fowise_details = this.props.fowise_detail.fowise_details;
        const summaries = this.props.fowise_detail.summary;

        return (
            <React.Fragment>

                <section>
                <div style={{ paddingBottom: 15 }}>
                                    <h5 style={{ textAlignLast: 'center' }}>Orders Awaiting Acknowledgment</h5>
                                </div>
                    <Tabs>
                        <div className='ack-tab-list'>

                            <TabList>
                                <Tab>
                                    <div>
                                    &emsp;FO Wise&emsp;&emsp;
                 </div>
                                </Tab>
                               
                                <Tab>
                                    <div>
                                    &emsp;&emsp;Summary&emsp;
                 </div>
                                </Tab>
                            </TabList>
                        </div>

                        <TabPanel>
                            <div className='container   ack-main' style={{ maxWidth: 'fit-content', paddingBottom: 100 }}>
                                
                                {fowise_details.map((fd_detail, index) => {
                                    let dateTime = fd_detail.fo_date;
                                    let date = dateTime.substr(0,10);
                                    return (
                                        <React.Fragment key={index}>
                                <div style={{ paddingBottom: 10 }}>
                                    <div className='row'>
                                        <div className='col'>
                                            <b>FO No</b>
                                        </div>
                                        <div className='col-1'>:</div>
                                        <div className='col'><b>
                                            {fd_detail.fo_no}</b>
                                        </div>

                                    </div>
                                    <div className='row'>
                                        <div className='col'>
                                            <b>FO Date</b>
                                        </div>
                                        <div className='col-1'>:</div>
                                        <div className='col'>
                                            <b>{date}  </b>
                                        </div>

                                    </div>
                                </div>
                                {fd_detail.product_details.map((product_detail, index) => {
                                return (
                                    <React.Fragment key={index}>
                                <div className='row' style={{ paddingBottom: 15 }}>
                                    <div className='col'>
                                        <div>
                                            {product_detail.brand}
                           </div>
                                        <div>
                                            {product_detail.category}
                           </div>
                                        <div>
                                            {product_detail.sku_code}
                           </div>
                           <div>{product_detail.color}/{product_detail.size}</div>
                                   
                                    </div>
                                    <div className='col'>
                                        <div>
                                            <img src={product_detail.sku_image !== null && product_detail.sku_image !== "" ? product_detail.sku_image : noImage} style={{ width: '65%' }} alt=''/>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col'>
                                        SKU Qty
                                    </div>
                                    <div className='col-1'>
                                        :
                                    </div>
                                    <div className='col'>
                                            {product_detail.sku_qty}&nbsp;Nos
                           </div>
                                </div>
                                
                                </React.Fragment> ) } ) } 
                                <hr/>

                             

                              
                                </React.Fragment>
                                    )
                                  
                                })} 

                            </div>
                        </TabPanel>



                        <TabPanel>
                            <div className='container ack-main' style={{paddingTop:20}}>
                                
                                {summaries.map((summary, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                <div className='row' style={{ paddingBottom: 15 }}>
                                    <div className='col'>
                                        <div>
                                            {summary.brand}
                           </div>
                                        <div>
                                            {summary.category}
                           </div>
                                        <div>
                                            {summary.sku_code}
                           </div>
                           <div >{summary.color}/{summary.size}</div>
                                    </div>
                                    <div className='col'>
                                        <div>
                                            <img src={summary.image !== null && summary.image !== '' ? summary.image : noImage} alt='' style={{ width: '65%' }} />
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col'>
                                        SKU Qty
                                    </div>
                                    <div className='col-1'>
                                        :
                                    </div>
                                    <div className='col'>
                                            {summary.sku_qty}&nbsp;Nos
                           </div>
                                </div>
                                <hr />
                                </React.Fragment>
                                    )
                                  
                                })} 

                            </div>
                        </TabPanel>
                    </Tabs>

                </section>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    connection_id: state.tenant.connection_id,
    fowise_detail: state.orderFulfillment



});


const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getOrderFulfillmentList },
        dispatch
    );


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Awaiting));

